import type { QuizResultsToggle } from '../quiz/QuizControls';
import { viewShown, type ResultPanelTab, type SessionInit } from './sessions';
import { useResultSessionStore } from './store';

function useViewToggle(init: SessionInit | null, view: ResultPanelTab): QuizResultsToggle {
  const tabId = init ? init.tabId : '';
  const open = useResultSessionStore((state) => Boolean(tabId) && viewShown(state.sessions[tabId], view));
  const onToggle = () => { if (init) useResultSessionStore.getState().toggleView(init, view); };
  return { open, onToggle };
}

// Kết quả and Chi tiết on a đề's own rail: each opens its view of this tab's results card
export function useUnitResultsToggle(init: SessionInit | null): { report: QuizResultsToggle; detail: QuizResultsToggle } {
  return { report: useViewToggle(init, 'stats'), detail: useViewToggle(init, 'detail') };
}
